module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-57.906279bb.svg";